export const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
export const isAndroid = /Android/i.test(window.navigator.userAgent);
export const isMobile = isIOS || isAndroid;
export const isIE = /MSIE|Trident/.test(window.navigator.userAgent);
/** HTML 属性値に埋め込む文字列をエスケープする（翻訳文に " 等が含まれても属性が壊れないように） */
export const escapeAttr = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/"/g, '&quot;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');
